<template>
  <div>
    <empty-card
      :table="true"
      :title="$t('reply.menu-templates')"
    >
      <template slot="title">
        <b-button
          size="md"
          variant="dark"
          class="mx-md-1"
          @click="$router.push({name:'owner:reply-template'})"
        >
          {{ $t('reply.add-template') }}
        </b-button>
      </template>
      <ok-table
        ref="datatable"
        :config="config"
        @edit="goEdit"
        @delete="handleDelete"
      >
        <template
          slot="message_type-column"
          slot-scope="{props}"
        >
          <b-badge variant="primary">
            {{ $t(`reply.${props.row.message_type}`) }}
          </b-badge>
        </template>
        <template
          slot="reply_type-column"
          slot-scope="{props}"
        >
          <b-badge variant="success">
            {{ $t(`reply.${props.row.reply_type==='generic'?'general_message':'filter_words'}`) }}
          </b-badge>
        </template>
      </ok-table>
    </empty-card>
  </div>
</template>

<script>
import { BBadge, BButton } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import EmptyCard from '@/@bya3/components/cards/EmptyCard'
import OkTable from '@/@bya3/components/tables/ok-table/OkTable'
import ReplyApi from '@/api/reply'
import ReplyTemplateTableConfig from './config/reply-templates-table-config'

export default {
  components: {
    EmptyCard,
    OkTable,
    BBadge,
    BButton,
  },
  data() {
    return {
      config: ReplyTemplateTableConfig,
      showOrdersModal: false,
      selectedClient: {},
    }
  },
  computed: {
    ...mapGetters({
      currentPageId: 'pages/currentPageId',
      currentPage: 'pages/currentPage',
    }),
  },
  watch: {
    currentPageId() {
      this.refreshTable()
    },
  },
  methods: {
    refreshTable() {
      this.showOrdersModal = false
      this.selectedClient = {}
      this.$refs.datatable.loadItems()
    },
    openOrdersModal(data) {
      if (!data.row?.orders?.length) return
      this.showOrdersModal = true
      this.selectedClient = data.row
    },
    getStatusVariant(report) {
      if (this.currentPage.package.count < report.replies_count) return 'danger'
      switch (report.status) {
        case 1: return 'danger'
        case 2: return 'warning'
        default: return 'success'
      }
    },
    getStatusText(report) {
      if (this.currentPage.package.count < report.replies_count) return this.$t('reply.is_enable_message')
      switch (report.status) {
        case 1: return this.$t('reply.stopped')
        case 2: return this.$t('reply.temp_stop')
        default: return this.$t('reply.running')
      }
    },
    goEdit(props) {
      this.$router.push({ name: 'owner:reply-template-edit', params: { id: props.row.id } })
    },
    handleDelete(data) {
      this.$okConfirm(this.$t('reply.delete-reply-template-message'), {
        preConfirm: () => ReplyApi.deleteReplyTemplate(data.row.id)
          .then(response => {
            this.$notifySuccess(response.message)
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
  },
}
</script>
